




















































import Vue from 'vue'
import CustomTable from './components/CustomTable.vue'
import CustomForm from './components/CustomForm.vue'
import CustomList from './components/CustomList.vue'
import EditForm from './components/EditForm.vue'
import {
  TenantAppServiceProxy,
  TenantAppVO,
  TenantAppQueryDTO,
  TenantVO
} from '@/service-proxies/app-v2/system.service-proxies'
const sp = new TenantAppServiceProxy()
export default Vue.extend({
  components: {
    CustomTable,
    CustomForm,
    CustomList,
    EditForm
  },
  data() {
    return {
      dataSource: [],
      visible: false,
      loading: false,
      tenant: {},
      editVisible: false,
      currentApp: {},
      canDelete: false
    }
  },
  methods: {
    async loadData(tenantId: string | undefined): Promise<void> {
      if (!tenantId) return
      this.loading = true
      const res: TenantAppVO[] = await sp.getGrantAPPList(tenantId)
      // this.dataSource = res

      let dataLength = res.length
      let copy = JSON.parse(JSON.stringify(res))
      let needPush = 0
      if (dataLength < 30) {
        needPush = 30 - dataLength
        for (var k = 0; k < needPush; k++) {
          let obj = {
            // id: 'none'
          }
          copy.push(obj)
        }
      }

      this.dataSource = JSON.parse(JSON.stringify(copy))

      this.loading = false
    },
    empower(): void {
      this.visible = true
    },
    async del(): Promise<void> {
      const body = new TenantAppQueryDTO({
        appCodeList: this.$refs.table.appCodeList,
        tenantId: this.tenant.tenantId
      })
      await sp.removeBatchAppCode(body)
      await this.loadData(this.tenant.tenantId)
    },
    cancel(): void {
      this.visible = false
    },
    onChoose(tenant: TenantVO): void {
      this.loadData(tenant.tenantId)
      this.tenant = tenant
    },
    onEdit(app: any) {
      // if (this.editVisible) {
      //   this.$confirm({
      //     title: this.$t('switch_tips_title'),
      //     content: this.$t('switch_tips_content'),
      //     onOk: () => {
      //       this.editVisible = true
      //       this.currentApp = app
      //     },
      //     onCancel() {
      //       return
      //     }
      //   })
      // } else {
      this.editVisible = true
      this.currentApp = app
      console.log(this.currentApp, 5656)
      // }
    },
    afterEdit() {
      this.loadData(this.tenant.tenantId)
      this.editVisible = false
    },
    afterAdd() {
      this.loadData(this.tenant.tenantId)
      this.visible = false
    },
    afterDel() {
      this.loadData(this.tenant.tenantId)
    }
  }
})
